<template>
  <rabbey-base-drawer :title="title" :drawer.sync="drawer" @close="handleClose">
    <el-row>
      <el-col :span="24">
        <el-form
          ref="form"
          :model="form"
          label-position="top"
          size="mini"
          label-width="120px"
          :rules="rules"
          v-loading="loading"
        >
          <!--categoria-->
          <el-form-item label="Categoria" prop="Type">
            <el-select
              v-model="form.Type"
              class="box-item"
              size="mini"
              clearable
            >
              <el-option
                v-for="cat in categories"
                :key="cat.value"
                :label="cat.label"
                :value="cat.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- TODO: si es un egreso, se debe elegir el ingreso padre -->

          <!--nombre-->
          <el-form-item label="Nombre" prop="Name">
            <el-input v-model="form.Name"></el-input>
          </el-form-item>

          <el-form-item label="Proyecta ?" prop="LookingForward">
            <el-switch
              v-model="form.LookingForward"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>

          <el-form-item label-width="0">
            <el-button type="primary" @click="onSubmit()" v-loading="loading"
              >Guardar
            </el-button>
            <el-button @click="onCancel()">Cancel</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
export default {
  name: "RowCashFlowForm",
  events: ["refresh"],
  props: {
    year: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      drawer: false,
      loading: false,
      formMode: "add", // or edit
      items: [],
      categories: [
        { value: 1, label: "Entradas de efectivo" },
        { value: 0, label: "Salidas de Efectivo" }
      ],
      rules: {
        Name: [{ required: true, message: "Nombre es requerido" }],
        Type: [{ required: true, message: "La Categoria es requerida" }]
      },
      form: {
        RenglondID: 0,
        Type: 0,
        Name: null,
        LookingForward: false,
        CompanyCode: null
      }
    };
  },
  computed: {
    title() {
      return this.formMode === "add" ? "Crear Renglón" : "Editar Renglón";
    },
    message() {
      return this.formMode === "add"
        ? "El Renglón fue creado!"
        : "El Renglón fue editado!";
    }
  },
  methods: {
    /**
     * Muestra el drawer en modo creacion si no se pasa el row de lo contrio
     * se muestra en modo edicion.
     * @param {RowCashflow} row Renglon
     */
    show(row, companyFilter) {
      if (row === undefined || row === null) {
        this.formMode = "add";
        this.form.CompanyCode =
          companyFilter === undefined ||
          companyFilter === null ||
          companyFilter === "ALL"
            ? this.currentCompany
            : companyFilter;
      } else {
        this.form = {
          RenglondID: row.Id,
          Type: row.Type,
          Name: row.Concept,
          LookingForward: row.LookingForward,
          CompanyCode: row.CompanyCode,
          year: this.year
        };
        this.formMode = "edit";
      }
      this.drawer = true;
    },

    handleClose() {
      this.$refs.form.resetFields();
      this.form = {
        RenglondID: 0,
        Type: 0,
        Name: null,
        LookingForward: false,
        CompanyCode: null
      };
    },

    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = this.form;
          data.year = this.year;
          this.$http
            .post("/api/CashFlow/AddOrUpdateRegnlon", data)
            .then(() => {
              this.$message({
                type: "success",
                message: this.message
              });
              this.$emit("refresh", data.RenglondID);
              this.drawer = false;
            })
            .catch((error) => {
              this.$message.error("Erro!");
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.drawer = true;
          return false;
        }
      });
    },
    onCancel() {
      this.drawer = false;
      this.handleClose();
    }
  }
};
</script>
